import React, { useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import mountainImg from '../Rating/mountain.jpg';
import styled from "styled-components";

const reviewsData = [
    {
        initials: "ER",
        name: "Elena Rodriguez",
        date: "July 20, 2024 at 4:00 PM",
        spot: "Mountain View Peak",
        text: "Absolutely breathtaking views! A must-visit. The online ticket process was smooth.",
        rating: 4,
        hasPhoto: true
    },
    {
        initials: "JS",
        name: "John Smith",
        date: "August 10, 2024 at 11:30 AM",
        spot: "Sunrise Valley",
        text: "Amazing place! Clean and well organized.",
        rating: 5,
        hasPhoto: true
    },
    {
        initials: "AM",
        name: "Aisha Malik",
        date: "September 5, 2024 at 6:45 PM",
        spot: "Green Lake",
        text: "A peaceful retreat with stunning natural beauty.",
        rating: 4,
        hasPhoto: true
    }
];

const OnlineTickets = () => {
    const [activeTab, setActiveTab] = useState("reviews");

    return (
        <Wrapper className="container py-5">
            <div className="card border-0 shadow-sm p-4">
                <h4 className="fw-bold text-dark">Ratings & Reviews</h4>
                <p className="text-muted mb-4">
                    See what users are saying and sharing about the partnered tourist spots.
                </p>
                <div className="d-flex mb-4">
                    <button
                        className={`btn me-2 border ${activeTab === "reviews" ? "btn-primary text-white" : "btn-light"}`}
                        onClick={() => setActiveTab("reviews")}
                    >
                        All Reviews
                    </button>
                    <button
                        className={`btn border ${activeTab === "photos" ? "btn-primary text-white" : "btn-light"}`}
                        onClick={() => setActiveTab("photos")}
                    >
                        User Photos
                    </button>
                </div>
                {activeTab === "reviews" && reviewsData.map((review, idx) => (
                    <div className="card p-3 shadow-sm border-0 mb-3" key={idx}>
                        <div className="d-flex justify-content-between">
                            <div>
                                <div className="d-flex align-items-start mb-3">
                                    <div
                                        className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center me-2"
                                        style={{ width: "35px", height: "35px", fontSize: "14px" }}
                                    >
                                        {review.initials}
                                    </div>
                                    <div>
                                        <div className="fw-bold text-dark">{review.name}</div>
                                        <div className="text-muted small">Reviewed on {review.date}</div>
                                    </div>
                                </div>
                                <div className="fw-semibold text-dark">Spot: {review.spot}</div>
                                <p className="text-muted mb-2">{review.text}</p>
                                {review.hasPhoto && (
                                    <button className="btn btn-outline-primary btn-sm">📷 Photo included</button>
                                )}
                            </div>
                            <div className="text-end">
                                {[...Array(review.rating)].map((_, i) => (
                                    <FaStar key={i} size={18} color="#f6c000" />
                                ))}
                                {[...Array(5 - review.rating)].map((_, i) => (
                                    <FaRegStar key={i} size={18} color="#f6c000" />
                                ))}
                            </div>
                        </div>
                    </div>
                ))}

                {/* Photos Section */}
                {activeTab === "photos" && (
                    <div className="card p-3 shadow-sm border-0 mb-3">
                        <div className="d-flex flex-wrap gap-3">
                            <div className="container p-3">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-sm-12 ">
                                        <div className="card shadow-sm border-0">
                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                            <div className="card-body">
                                                <div className="fw-bold text-dark">Mountain View Peak</div>
                                                <div className="text-muted small">By: Elena Rodriguez</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                        <div className="card shadow-sm border-0">
                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                            <div className="card-body">
                                                <div className="fw-bold text-dark">Sunset Cliffs</div>
                                                <div className="text-muted small">By: Rahul Mehta</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                        <div className="card shadow-sm border-0">
                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                            <div className="card-body">
                                                <div className="fw-bold text-dark">Crystal Lake</div>
                                                <div className="text-muted small">By: Sara Kim</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                        <div className="card shadow-sm border-0">
                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                            <div className="card-body">
                                                <div className="fw-bold text-dark">Majestic Falls</div>
                                                <div className="text-muted small">By: RatherFord</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 pb-4">
                                        <div className="card shadow-sm border-0">
                                            <img src={mountainImg} alt="Mountain View" className="mountain-img rounded-top" />
                                            <div className="card-body">
                                                <div className="fw-bold text-dark">Majestic Falls</div>
                                                <div className="text-muted small">By: James Anderson</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Wrapper>
    );
};

export default OnlineTickets;

const Wrapper = styled.div`
  .card.p-3.shadow-sm.border-0 {
    background-color: #fafafa !important;
  }

  .mountain-img {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }
`;
